<template>
  <div>
    <basic-container v-loading="loading">
      <h3 class="title mB-30">供应链服务协议</h3>
      <div v-if="isLoaded">
        <div v-if="tableData && tableData.length">
          <el-table :data="tableData">
            <el-table-column label="协议ID" prop="appointNo" align="center" />
            <el-table-column label="生效时间" prop="startTime" align="center" />
            <el-table-column label="失效时间" prop="endTime" align="center" /> 
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="formData.page"
              :page-size.sync="formData.size"
              :page-sizes="[20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              :total.sync="total"
              background
            />
          </div>
        </div>
        <div class="no-appoint" v-else>
          代采未有有效的供应链服务协议。如有相关需要，可联系业务经理开通
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        page: 1,
        size: 20
      },
      total: 0,
      loading: false,
      tableData: [],
      isLoaded: false
    }
  },
 
  mounted() {
    this.search()
  },
  methods: {
    search() {
      this.formData.page = 1
      this.getAppointList()
    },
    async getAppointList() {
      this.loading = true
      const res = await _api.appoint.getPurchaseAppointList(this.formData)
      this.loading = false
      if (!res || !res.ret || !res.data) {
        this.tableData = []
        this.total = total
        this.isLoaded = true
        return
      }
      const { data, total } = res.data
      this.tableData = data || []
      this.total = total
      this.isLoaded = true
    },
    handleSizeChange(val) {
      this.formData.page = 1
      this.getAppointList()
    },
    handleCurrentChange(val) {
      this.getAppointList()
    },
    toDetail(row) {
      this.$router.push({
        path: "/purchaseAppoint/detail",
        query: {
          appointNo: row.appointNo,
          type: '1'
        }
      })
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 16px;
  color: #409eff;
}

.no-appoint {
  color: #FF4500;
  text-align: center;
  height: 500px;
  margin-top: 60px;
}
</style>
